import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  data: {
    revenue: [],
    purchases: [],
    sessions: [],
    avgSessionLength: [],
  },
};

const saveMasterCardsDataSlice = createSlice({
  name: "Update the master data of the cards in admin dashboard",
  initialState,
  reducers: {
    updateMasterCardsData(state, action) {
      state.isLoading = true;
      try {
        state.data = action.payload;
      } finally {
        state.isLoading = false;
      }
    },
    resetMasterCardsData(state) {
      state.data = initialState.data;
    },
  },
});

export const { updateMasterCardsData, resetMasterCardsData } = saveMasterCardsDataSlice.actions;
export default saveMasterCardsDataSlice.reducer;
